export default {
  setAuth: (state, auth) => {
    state.auth = auth;
  },

  toggleMenu: state => {
    state.isMenuMinimized = !state.isMenuMinimized;
  },

  setLastSignupStep: (state, step) => {
    state.lastSignupStep = step;
  },

  setLandingUrl: (state, landingURL) => {
    state.landingURL = landingURL;
  },

  setNewCampaignId: (state, newCampaignId) => {
    state.newCampaignId = newCampaignId;
  },

  setCompany: (state, company) => {
    state.company = company;
  },

  setCampaign: (state, campaign) => {
    state.campaign = campaign;
  },

  setCompanyBalances: (state, balances) => {
    state.companyBalances = balances
  },

  setWhiteLabel: (state, isWhiteLabel) => {
    state.isWhiteLabel = isWhiteLabel
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js